import {useState} from 'react'

type TypeFetching = [(...args: any[]) => void, boolean, string | unknown]

function useFetching(callback: (...args: any[]) => void): TypeFetching {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | unknown>('')

  const fetching = async (...args: any[]) => {
    try {
      setIsLoading(true)
      await callback(...args)
    } catch (e) {
      setError(e)
    } finally {
      setIsLoading(false)
    }
  }
  return [fetching, isLoading, error]
}

export default useFetching
